import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthComponent } from './auth.component';
import { LoginComponent } from './login/login.component';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ThemeModule } from '../../@theme/theme.module';
import { PartialsModule } from '../../partials/partials.module';
import { KragUtilitiesService } from '../../@core/utils/krag-utilities.service';
import {CloudinaryModule} from '@cloudinary/ng';
import { NbCardModule } from '@nebular/theme';





@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		MatButtonModule,
		CloudinaryModule,
		MatInputModule,
		MatFormFieldModule,
		MatCheckboxModule,
		PartialsModule,
		NbCardModule,
		ThemeModule.forRoot(),
		RouterModule.forChild([
			{
				path: '',
				component: AuthComponent
			}
		])
	],
	providers: [
		KragUtilitiesService
	],
	declarations: [
		AuthComponent,
		LoginComponent,
	],
})
export class AuthModule {}
